import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//stores
import { useUserStore } from 'stores';
//components
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input/index.js';

const FiltersTable = ({
  formFilter,
  setFormFilter,
  handleClear,
  t,
  page,
  setPage,
  itemsBenefitedCompany,
  itemsCommissionStatus
}) => {
  const { profile } = useUserStore();

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable
      handleClear={handleClear}
      multipleInput={true}
      className="d-flex align-items-center"
      md={9}
    >
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        {profile !== 'library' && (
          <SelectInputCustom
            choices={itemsBenefitedCompany}
            label={t('benefited_company')}
            placeholder={t('benefited_company')}
            onCheckedItem={(e) => handleSearch(e, 'benefited_company')}
            value={formFilter.benefited_company}
            className="d-flex align-items-center"
          />
        )}
        <SelectInputCustom
          choices={itemsCommissionStatus}
          label={t('commision_status')}
          placeholder={t('commision_status')}
          onCheckedItem={(e) => handleSearch(e, 'commission_status')}
          value={formFilter.commission_status}
          className="d-flex align-items-center"
        />
      </Form>
    </SearchTable>
  )
}

FiltersTable.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func,
  itemsBenefitedCompany: PropTypes.array,
  itemsCommissionStatus: PropTypes.array,
};

export default FiltersTable;
